<!-- 头部导航 -->
<template>
  <div>
    <!-- 通知弹窗 -->
    <div class="resume" v-show="maskShow">
      <div class="mask" @click="closeMaskShow" v-show="maskShow"></div>
      <div class="resumeBox" v-show="maskShow">
      	<div class="close ">
          <img @click="closeMaskShow" src="../../static/pC/close-green.png"></img>
        </div>
      	<div class="t">通知</div>
        <div class="flex-c-c">
          <div class="line"></div>
        </div>
      	<div class="detail">
          <div class="ly flex-s-c">
            <span style="color: #345C4E;margin-right: 10px;">{{houseName}}</span>
            <span>{{whereFrom}}</span>
          </div>
      		<div class="box flex-s-c">
      			<div class="left"><img src="../../static/pC/19.png"></img></div>
      			<input placeholder="请输入手机号" v-model="phone" style="width: 100%;" />
      		</div>

      		<div class="flex-c-c">
            <div class="submit flex-c-c" @click="submitPhone">确认</div>
           </div>
      		<div class="radio-box flex-s-s">
            <div>
              <el-checkbox v-model="checked"></el-checkbox>
            </div>
      			<div class="tk">
      			  <span class="tb">我已阅读并接受</span>
      			  <span style="color: #345C4E;cursor: pointer;" @click="openShowAgreement(1)">《易购好房用户隐私政策》</span>
      			  <span>及</span>
      			  <span style="color: #345C4E;cursor: pointer;" @click="openShowAgreement(2)">《易购好房用户服务协议》</span>
      			</div>
      		</div>
      	</div>
      </div>
    </div>

    <!-- 协议内容弹窗 -->
    <div class="resume" v-show="showAgreement">
      <div class="mask" v-show="showAgreement"></div>
      <div class="resumeBox" v-show="showAgreement">
      	<div class="close">
          <img @click="closeShowAgreement()" src="../../static/pC/close-green.png"></img>
        </div>
        <div class="t">{{cont.title}}</div>
        <div class="flex-c-c">
          <div class="line"></div>
        </div>
        <div class="flex-c-c">
          <div class="agreement">
            <div>
                <div v-html="cont.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {  apiLoginSubmitPhone, apiGetCodeNum, apiExitLogin, apiSubmit, apiGetAgreement, apiGetPolicy  } from '../api/login.js';
export default {
  name: 'SanTable',
  props: {
    sellId: {
      type: String, //传参类型
      default: '' //默认参数
    },
    houseName: {
      type: String, //传参类型
      default: '' //默认参数
    },
    whereFrom: {
      type: String, //传参类型
      default: '' //默认参数
    },
    maskShow: {

    },

  },
  data() {
    return {
      login: 'false', //判断是否登录
      userInfo: [], //用户信息

      checked: false,//复选框是否勾选
      phone: '', //手机号

      showAgreement: false,//协议弹窗时候打开
      cont:{},//协议内容
    };
  },
  created() {
   this.judgeLogin();
  },
  mounted() {
  },
  methods: {
    //打开协议
    openShowAgreement(num){
      if(num == 1){
        this.getPolicy()
      }
      if(num == 2){
        this.getAgreement()
      }
      this.showAgreement = true
    },

    //关闭协议
    closeShowAgreement(){
       this.showAgreement = false
    },

    //获取协议内容
    getAgreement(){
      this.$loading();
      apiGetAgreement()
        .then(res => {
          if (res.success) {
            this.cont = res.data
          } else {
            this.$message({ message: res.msg, type: 'error', duration: 1000, });
          }
          this.$loading().close();
        })
        .catch(err => {
          this.$message({ message: res.msg, type: 'error', duration: 1000, });
          this.$loading().close();
        });
    },

    //获取隐私政策
    getPolicy(){
      this.$loading();
      apiGetPolicy()
        .then(res => {
          if (res.success) {
            this.cont = res.data
          } else {
            this.$message({ message: res.msg, type: 'error', duration: 1000, });
          }
          this.$loading().close();
        })
        .catch(err => {
          this.$message({ message: res.msg, type: 'error', duration: 1000, });
          this.$loading().close();
        });
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
          this.phone = this.userInfo.phone
        }
      }
    },

    //通知提交
    submitPhone() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message.error('请输入正确的手机号');
        return false;
      }
      if (!this.checked) {
        this.$message.error('请阅读并同意协议');
        return false;
      }
      var remark = this.houseName + '_' + this.whereFrom
      apiSubmit({
        customerId: this.userInfo.id,
        fromWay: this.whereFrom,
        remark: remark,
        leavePhone: this.phone,
        userId: this.sellId,
      })
        .then(res => {
          if (res.success) {
            this.$message({ message: '提交成功', type: 'success' });
            this.closeMaskShow();
          } else {
            this.$message({ message: res.msg, type: 'error' });
          }
        })
        .catch(err => {
          this.$message({ message: '账号密码错误', type: 'error' });
        });
    },

    //调用父组件方法关闭通知弹窗
    closeMaskShow() {
      this.$parent.closeSanTable();
      this.check = false;
      this.phone = '';
      this.code = '';
    },


    //跳转链接
    linkPage(url) {
      this.$router.push({ path: url, query: {} });
    }
  }
};
</script>
<style scoped>
/deep/ .el-checkbox__label { display: inline-block;padding-left: 10px;line-height: 20px;font-size: 16px;color: #345c4e;}
/deep/ .el-checkbox__inner {display: inline-block;position: relative;border-color: #345c4e !important; border: 1px solid #345c4e;border-radius: 2px;-webkit-box-sizing: border-box; box-sizing: border-box;width: 20px; height: 20px;background-color: #FFF;z-index: 1;-webkit-transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);}
/deep/ .el-checkbox__inner::after {-webkit-box-sizing: content-box; box-sizing: content-box; content: ""; border: 1px solid #FFF; border-left: 0;border-top: 0;height: 10px;left: 6px;position: absolute;top: 2px;-webkit-transform: rotate(45deg) scaleY(0);transform: rotate(45deg) scaleY(0);width: 6px;-webkit-transition: -webkit-transform .15s ease-in .05s;transition: -webkit-transform .15s ease-in .05s;transition: transform .15s ease-in .05s;transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s;transition: transform .15s ease-in .05s,-webkit-transform .15s ease-in .05s;-webkit-transform-origin: center;transform-origin: center;}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {background-color: #345c4e;border-color: #345c4e;}
.header-box {
  width: 100%;
  min-height: 0px;
  background: #ffffff;
}
.header {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 5px;
}
.header .cont {
  width: 100%;
}

.header .nav {
  margin-right: 12%;
}
.header .nav ul li {
  height: 65px;
  display: inline-block;
  text-align: center;
  line-height: 65px;
  font-size: 16px;
  font-weight: 400;
  padding: 0 30px;
  cursor: pointer;
}
.header .nav .onS {
  color: #345c4e;
  background-image: linear-gradient(to right, #345c4e, #345c4e);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 35% 2px;
  cursor: pointer;
}
.header .nav .on {
  color: #345c4e;
  background-image: linear-gradient(to right, #ffffff, #ffffff);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 35% 2px;
  cursor: pointer;
}

.header .operation {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.header .operation .nav-btn {
  color: #345c4e;
  margin-left: 10px;
  cursor: pointer;
}
.header .operation .nav-green {
  color: #345c4e;
  margin-left: 10px;
}
.header .operation .nav-white {
  color: #ffffff;
  margin-left: 10px;
}

.header .operation .head-img {
  width: 40px;
  height: 40px;
  margin-left: 20px;
  border-radius: 50%;
}
.header .operation .down-icon img {
  width: 11px;
  height: 6px;
  margin-left: 7px;
}
.header .operation .login-icon img {
  width: 15px;
  height: 15px;
}
.select {
  position: absolute;
  right: 0;
  top: 100%;
  width: 160px;
}
.selectBox {
  margin-top: 0px;
  z-index: 100;
  width: 180px;
  background: #ffffff;
  position: relative;
}
.selectBox ul {
  padding: 13px 0;
  background-color: #f5f5f5;
}
.selectBox li {
  height: 40px;
  z-index: 200;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
}
.selectBox li img {
  padding-right: 10px;
}

/* 登录弹窗 */
.resume {
  width: 100%;
  height: 100%;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.resumeBox {
  position: fixed;
  width: 600px;
  background: #ffffff;
  border: 1px solid #ccc;
  text-align: center;
  top: calc(50% - 250px);
  left: calc(50% - 300px);
  min-height: 572px;
  border-radius: 10px;
  z-index: 9999
}
.resumeBox .close {
  margin-right: 30px;
  margin-top: 30px;
}
.resumeBox .close img{
  width: 46px;
  height: 46px;
}
.resumeBox .t{
  font-size: 36px;
  font-weight: bold;
  color: #345C4E;
  width: 100%;
  text-align: center;
  margin-top: 60px;
  padding-left: 50px;
}
.resumeBox .line{
  width: 75%;
  height: 2px;
  background-color: #345C4E;
  margin-top: 20px;
}
.resumeBox .detail{
  padding: 0 70px;
  margin-top: 50px;
}
.resumeBox .detail .ly{
  width: 100%;
  font-size: 24px;
  color: #333333;
}
.resumeBox .detail .box{
  width: 100%;
  line-height: 60px;
  margin-top: 20px;
  border-bottom: 1px solid #EEEEEE;
}
.resumeBox .detail .box .left img{
  width: 34px;
  height: 34px;
  margin-right: 15px;
}
.resumeBox .detail .box input{
  padding-right: 20px;
}
.resumeBox .detail .box input{
  padding-right: 20px;
}
.resumeBox .detail .box .code{
  cursor: pointer;
}
.resumeBox .submit{
  width: 100%;
  height: 60px;
  background: #345C4E;
  border-radius: 10px;
  font-size: 24px;
  color: #FFFFFF;
  margin-top: 30px;
}
.resumeBox .radio-box{
  margin-top: 25px;
  text-align: left;
}
.resumeBox .radio-box .tk{
  margin-left: 10px;
  font-size: 16px;
  color: #345C4E;
}
.resumeBox .radio-box .tk .tb{
 font-size: 16px;
 color: #333333;
}
/* 协议内容弹窗 */
.agreement {
  width: 450px;
  height: 380px;
  margin: 20px 0;
  border: 1px solid #A4A8BB;
  overflow: hidden;
}
.agreement > div {
  width: 467px;
  height: 380px;
  text-align: center;
  overflow-y: scroll;
}




@media (max-width: 1200px) {
  .header {
    padding: 0 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SanTable.vue